import { Component, Input, OnInit } from '@angular/core';
import { AlertService, IAlertType, RequestsStoreService } from "../../../../_shared/services";
import { Requests, StatusButtons } from '../../../../_shared/interfaces';
import { ClrDatagridModule, ClrDatagridSortOrder } from '@clr/angular'
import { RouterLink } from "@angular/router";
import { CurrencyPipe, DatePipe } from "@angular/common";

@Component({
  selector: 'app-project-details-requests',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    CurrencyPipe
  ],
  templateUrl: './project-details-requests.component.html',
  styleUrl: './project-details-requests.component.sass'
})
export class ProjectDetailsRequestsComponent implements OnInit {
  requests: Requests[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusText = '';

  projectId: string = '';

  @Input() cid: number = 0;
  @Input() prid: string = '';


  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'running', display: 'Abgeschickt', label: 'alert-info', icon: 'info-circle'},
    { state: 'rejected', display: 'Abgelehnt', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'too expensive', display: 'Zu teuer', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'ignored', display: 'Ignoriert', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'answered', display: 'Beantwortet', label: 'alert-info', icon: 'info-circle'},
    { state: 'favored', display: 'Auftrag', label: 'alert-success', icon: 'check-circle'},
  ];

  constructor(
      private reqss: RequestsStoreService,
      private alertDispatcher: AlertService,
  ) { }

  ngOnInit() {
    this.loading = true;
    this.projectId = this.cid + '.' + this.prid;
    this.loadList(this.projectId);
  }

  loadList(projectId: string) {
    this.reqss.getRequests(projectId, 0, 'all').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Anfragen gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
          return;
        }
        this.requests = data.object;
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      }
    });
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(status: string) {
    const statusline = this.findButtonStatus(status, this.statusButtons);
    return {
      'statusLabel': this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus).statusLabel + " alert-sm";
  }
}
